/**
 * App-wide fallback for an uncaught render or loader error, wired as the
 * router's `defaultErrorComponent` (main.tsx). Without it, TanStack Router
 * shows its bare default screen with no way forward — a dead end on a booth
 * device. This gives the user an exit: reload the app, or return to the board.
 * A full navigation (not a client transition) is deliberate — it tears down
 * the crashed React tree rather than trying to recover in place.
 */
import { Button } from '@/components/ui/button';

export function ErrorScreen() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-sm flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="font-heading text-xl font-semibold">Something went wrong</h1>
      <p className="text-sm text-muted-foreground">
        The app hit an unexpected error. Anything already saved is safe — reload to continue.
      </p>
      <div className="flex gap-2">
        <Button onClick={() => window.location.reload()}>Reload</Button>
        <Button
          variant="outline"
          onClick={() => {
            window.location.href = '/';
          }}
        >
          Back to buyers
        </Button>
      </div>
    </div>
  );
}
